import { render, staticRenderFns } from "./mail.vue?vue&type=template&id=50ab7398&scoped=true&"
var script = {}
import style0 from "./mail.vue?vue&type=style&index=0&id=50ab7398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ab7398",
  null
  
)

export default component.exports